import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import BasicButton from "@/components/button/BasicButton"

import "./equipmentsSearch.scss"
import Search from "@/components/form/search/Search"

export default function EquipmentsSearch({
  onSearch,
  onClickDelivery,
}: {
  onSearch: (value: string) => void
  onClickDelivery: () => void
}) {
  const { t } = useTranslation()
  const [value, setValue] = useState("")

  useEffect(() => {
    onSearch(value)
  }, [value])

  return (
    <div className="EquipmentsSearchCont">
      <Search onChange={(value) => setValue(value)} />
      <BasicButton type="default-outlined" size="md" onClick={onClickDelivery}>
        {t("delivery")}
      </BasicButton>
    </div>
  )
}
